import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=7bedc609&scoped=true"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=7bedc609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bedc609",
  null
  
)

export default component.exports